import { useState, useEffect } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing(!isShowing);
  }

  useEffect(() => {
    const html = document.querySelector('html');

    if (html) {
      if (isShowing && html) {
        html.style.overflowY = 'hidden';
      } else {
        html.style.overflowY = 'visible';
      }
    }
  }, [isShowing]);

  return {
    isShowing,
    toggle,
  };
};

export default useModal;
